import React, { useState } from 'react';
import { API_BASE } from '../lib/apiBase';
import { useT } from '../i18n/langContext.js';

// Bump this whenever the wording of the consent copy (chat.contactRequest.
// consentText) changes materially — stored alongside each contact request
// as consentVersion, so we can demonstrate which copy a user actually
// agreed to (GDPR Art. 7(1) puts the burden of proof on us, not on the
// user). NOTE: this version is not per-language — it tracks the Italian
// source wording; translating it into English without changing its legal
// meaning doesn't need a bump.
const CONSENT_VERSION = '2026-09-23';

export default function ContactRequestWidget({ defaultEmail, getIdToken, sessionId }) {
  const t = useT();
  const [consent, setConsent] = useState(false);
  const [phone, setPhone] = useState('');
  const [sending, setSending] = useState(false);
  const [done, setDone] = useState(false);
  const [error, setError] = useState(false);

  if (done) {
    return <div className="contact-request-widget contact-request-widget--done">{t('chat.contactRequest.doneMessage', { email: defaultEmail })}</div>;
  }

  const submit = async () => {
    setSending(true);
    setError(false);
    try {
      const idToken = await getIdToken();
      const headers = { 'Content-Type': 'application/json' };
      if (idToken) headers.Authorization = `Bearer ${idToken}`;
      const res = await fetch(`${API_BASE}/contact-request`, {
        method: 'POST',
        headers,
        body: JSON.stringify({ phone, sessionId: sessionId || '', consentVersion: CONSENT_VERSION }),
      });
      if (!res.ok) throw new Error(`contact-request HTTP ${res.status}`);
      setDone(true);
    } catch (e) {
      console.warn('contact-request submit failed:', e);
      setError(true);
    } finally {
      setSending(false);
    }
  };

  return (
    <div className="contact-request-widget">
      <div className="contact-request-widget__consent">
        <input
          type="checkbox"
          aria-label={t('chat.contactRequest.consentAria')}
          checked={consent}
          onChange={(e) => setConsent(e.target.checked)}
        />
        <span>{t('chat.contactRequest.consentText')}<a href="/privacy" target="_blank" rel="noopener noreferrer">{t('chat.contactRequest.privacyLink')}</a>.</span>
      </div>
      <input
        type="email"
        value={defaultEmail || ''}
        readOnly
        aria-label={t('chat.contactRequest.emailAria')}
        className="contact-request-widget__input"
      />
      <label htmlFor="contact-request-phone" className="contact-request-widget__label">{t('chat.contactRequest.phoneLabel')}</label>
      <input
        id="contact-request-phone"
        type="tel"
        value={phone}
        onChange={(e) => setPhone(e.target.value)}
        aria-label={t('chat.contactRequest.phoneLabel')}
        className="contact-request-widget__input"
      />
      {error && (
        <div className="contact-request-widget__error" role="alert">
          {t('chat.contactRequest.errorMessage')}
        </div>
      )}
      <button type="button" disabled={!consent || sending} onClick={submit}>
        {t('chat.contactRequest.submit')}
      </button>
    </div>
  );
}
